import { z } from "zod";

// Zod v4 API: use z.email() with error param, NOT z.string().email()
export const waitlistSchema = z.object({
  email: z.email({ error: "Please enter a valid email address" }),
  // Optional UTM source / trigger button identifier from the client
  source: z.string().optional(),
});

// TypeScript type inferred from schema — single source of truth
export type WaitlistFormData = z.infer<typeof waitlistSchema>;
